exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-content[data-v-789e6a00] {\n  display: flex; /* Utilizamos flexbox */\n  align-items: center; /* Centramos verticalmente */\n}\n.menu-text-container[data-v-789e6a00] {\n  flex-grow: 1; /* El texto ocupará todo el espacio disponible */\n  text-align: center; /* Centramos el texto horizontalmente */\n}\n.icon[data-v-789e6a00] {\n  margin-right: 10px; /* Ajusta el espacio entre el icono y el texto según sea necesario */\n}\n", ""]);

// exports
